import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import InputField from "./InputField";
export const NumberField = ({ name, label, required, min, max, step, }) => (_jsx(InputField, { name: name, label: label, required: required, type: "number", min: min, max: max, step: step }));
export default NumberField;
